import React, { useState } from "react";
import ExpiryCell from "./ExpiryCell";
import ViewDocsModal from "./ViewDocsModal";

export default function VehicleTable({ vehicles, onEdit, onDelete }) {
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  return (
    <div>
      <table className="table table-bordered table-striped">
        <thead className="table-dark">
          <tr>
            <th>Vehicle No.</th>
            <th>Tax</th>
            <th>Fitness</th>
            <th>Insurance</th>
            <th>Pollution</th>
            <th>Permit</th>
            <th>Driver</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {vehicles.map((vehicle) => (
            <tr key={vehicle.number}>
              <td>{vehicle.number}</td>
              <ExpiryCell date={vehicle.taxExpiry} />
              <ExpiryCell date={vehicle.fitnessExpiry} />
              <ExpiryCell date={vehicle.insuranceExpiry} />
              <ExpiryCell date={vehicle.pollutionExpiry} />
              <ExpiryCell date={vehicle.permitExpiry} />
              <td>{vehicle.fitness_file_name}</td>

              <td>
                <button
                  className="btn btn-primary btn-sm me-1"
                  onClick={() => onEdit(vehicle)}
                >
                  Edit
                </button>
                <button
                  className="btn btn-danger btn-sm me-1"
                  onClick={() => onDelete(vehicle.number)}
                >
                  Delete
                </button>
                <button
                  className="btn btn-success btn-sm"
                  onClick={() => setSelectedVehicle(vehicle)}
                >
                  View Document
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Docs Popup */}
      {selectedVehicle && (
        <ViewDocsModal
          vehicle={selectedVehicle}
          onClose={() => setSelectedVehicle(null)}
        />
      )}
    </div>
  );
}
